<template>
  <div id='bd-main'>
    <el-table :data="userCustomers.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="name" label="姓名" width="180"></el-table-column>
      <el-table-column prop="mobile" label="手机"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="age" label="年龄"></el-table-column>
      <el-table-column prop="job" label="职业"></el-table-column>
      <el-table-column prop="company" label="公司"></el-table-column>
      <el-table-column prop="description" label="备注"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <!-- <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small">
            查看
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userCustomers.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'userCustomers' ])
  },
  methods: {
    ...mapActions([ 'queryCustomers' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.queryCustomers(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.queryCustomers(payload)
  },

}
</script>

<style scoped>

</style>
